import { Descendant } from "slate";

import { BaseApi } from "../base";

export interface ICreatePayload {
  richTextObj: Descendant[];
  shortcuts: string[];
  teamId?: string;
  transactionId?: string;
}

export interface IUpdatePayload {
  id: string;
  richTextObj: Descendant[];
  shortcuts: string[];
  teamId?: string;
  transactionId?: string;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function parseCreatePayload(payload: ICreatePayload) {
  return {
    teamID: payload.teamId,
    richTextObj: payload.richTextObj,
    shortcuts: payload.shortcuts,
    ...(payload.transactionId ? { transactionID: payload.transactionId } : {}),
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function parseUpdatePayload(payload: IUpdatePayload) {
  return {
    teamID: payload.teamId,
    richTextObj: payload.richTextObj,
    shortcuts: payload.shortcuts,
    ...(payload.transactionId ? { transactionID: payload.transactionId } : {}),
  };
}

export default class CannedResponsesApi extends BaseApi {
  protected readonly prefix = "cannedResponses";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch = (id: string) => this.get(id);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchAll = () => this.get();
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  create = (payload: ICreatePayload) => this.post("", parseCreatePayload(payload));
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  update = (payload: IUpdatePayload) => this.patch(payload.id, parseUpdatePayload(payload));
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteCannedResponse = (id: string) => this.delete(id);
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteCannedResponseAttachment = (id: string, attachmentIndex: number) =>
    this.delete(`${id}/attachments/${attachmentIndex}`);
}
